const style = `
  position: relative;
  border-radius: 8px;
  padding: .5em 1em;

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    cursor: inherit;
    color: #cecece;
    border-color: #cecece;
  }

`

export default style
